import * as React from "react"
import { Captions } from './wraps'


const TxtBlock = ({ block, index }) => {
  return (
    <Captions item={block.captions} is_text={true} index={index} mid={block.id} />
  )
}

export   {  TxtBlock }



